import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { KbEntry } from "@shared/models/kb-entry"
import BelongTo from "cc-frontend/helpers/belong-to"
import HasManyAltogether from "cc-frontend/helpers/has-many-altogether"
import type EmberStore from "cc-frontend/services/ember-store"
import { use } from "ember-could-get-used-to-this"
import { find } from "lodash-es"
import styles from "./chapter.module.css"

interface Signature {
  Element: HTMLDivElement
  Args: {
    entry: KbEntry
    useIntro: boolean
  }
  Blocks: {
    default: any
  }
}

export default class KbEntryChapter extends Component<Signature> {
  readonly styles = styles

  @service("ember-store") declare store: EmberStore

  @use fiscalGroup = new BelongTo(() => [this.args.entry, "child"])
  @use sections = new HasManyAltogether<KbEntry>(() => [this.args.entry, "children", "kb-entry"])
  @use ancestors = new HasManyAltogether<KbEntry>(() => [this.args.entry, "ancestors", "kb-entry"])

  get part() {
    return find(this.ancestors.content, (ancestor) => {
      return ancestor.meta.type === "part"
    })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Kb::Entry::Chapter": typeof KbEntryChapter
  }
}
